module.exports = __webpack_public_path__ + "static/img/ex_logo_23.0282e99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ex/ex_logo_23.jpg
// module id = 5kcj
// module chunks = 0